import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Helper } from 'Components';
import i18n from 'i18next';
import { Link } from 'react-router-dom';

const formatCell = (props, key) => {
  if (key === 'ReportDate') {
    const value = props[key];
    if (!value || value === '-') return '-';
    return new Date(value).toLocaleDateString();
  }

  return props[key] === i18n.t('common:Not Specified') ? '' : props[key];
};

const SplitReportSubTableTemplate = (props) => {
  const {
    isRowLoading,
    handleDownload,
    keys,
    tempUpdateSplitReportRequestData,
    DownloadLink = '',
    SplitReportId,
  } = props;

  return (
    <Fragment>
      <tr className="invoices-list__sub-template">
        {keys.map((key) => (
          <td key={key}>
            {key === 'DownloadLink' ? (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a onClick={(e) => handleDownload(e, SplitReportId)} href="">
                <Helper text={i18n.t('tutorials:invoices.3')}>
                  {/* ? FIXME: remove the || "Download URL once finally implemented" */}
                  {DownloadLink || 'Download URL'}
                </Helper>
              </a>
            ) : (
              formatCell(props, key)
            )}
          </td>
        ))}
      </tr>
    </Fragment>
  );
};

SplitReportSubTableTemplate.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string),
};

export default SplitReportSubTableTemplate;



// WEBPACK FOOTER //
// ./src/containers/Jobs/SplitReportTab/SplitReportSubTableTemplate.jsx